import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import StakeholderService from "./StakeholderService";


export const getStakeholders = createAsyncThunk("Stakeholder/get-Stakeholders", async (thunkAPI) => {
  try {
    return await StakeholderService.getStakeholders();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createStakeholders = createAsyncThunk(
  "Stakeholder/create-Stakeholders",
  async (StakeholderData, thunkAPI) => {
    try {
      return await StakeholderService.createStakeholders(StakeholderData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getStakeholder = createAsyncThunk(
  "Stakeholder/get-Stakeholder",
  async (id, thunkAPI) => {
    try {
      return await StakeholderService.getStakeholder(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateStakeholder = createAsyncThunk(
  "Stakeholder/update-Stakeholder",
  async ({ id, isVerified }, thunkAPI) => {
    try {
      return await StakeholderService.updateStakeholder(id,isVerified);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAStakeholder = createAsyncThunk(
  "Stakeholder/delete-Stakeholder",
  async (id, thunkAPI) => {
    try {
      return await StakeholderService.deleteStakeholder(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Stakeholders: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const StakeholderSlice = createSlice({
  name: "Stakeholder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStakeholders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getStakeholders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Stakeholders = action.payload.data;
      })
      .addCase(getStakeholders.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createStakeholders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createStakeholders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdStakeholder = action.payload;
      })
      .addCase(createStakeholders.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getStakeholder.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getStakeholder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Stakeholders = action.payload.data;
      })
      .addCase(getStakeholder.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateStakeholder.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateStakeholder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedStakeholder = action.payload;
      })
      .addCase(updateStakeholder.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAStakeholder.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAStakeholder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedStakeholder = action.payload;
      })
      .addCase(deleteAStakeholder.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default StakeholderSlice.reducer;
